import poll from '../../utils/function/poll';

type TransactionStatuses = 'COMPLETED' | 'FAILED' | 'CANCELLED' | 'PENDING';

type openPopupWindowProps<T> = {
  url: string;
  checkoutSessionId: string;
  checkoutSessionsResponse: T;
  checkStatus?: () => Promise<{status: TransactionStatuses; response: T}>;
  onSuccess?: (checkoutSessionId: string, result: T) => void | undefined;
  onFailure?: (checkoutSessionId: string, result: T, httpError: HTTPErrorResponse) => void | undefined;
  onCancel?: (checkoutSessionId: string, result?: T) => void | undefined;
};

const POPUP_WINDOW_CLOSED_CHECK_INTERVAL = 2000;
const POLL_FOR_CHECKOUT_STATUS_CHECK_INTERVAL = 2000;

export function openPopupWindow<T = any>(
  params: openPopupWindowProps<T> | Promise<openPopupWindowProps<T>>,
  win: Window | null,
): [Promise<{status: TransactionStatuses; result?: T}>, Window | null] {
  const openWindowPromise = Promise.resolve(params).then((paramsPromise) => {
    // if (win) {
    //   // eslint-disable-next-line no-param-reassign
    //   win.location = paramsPromise.url;
    // } else {
    //   throw Error('window not initialized');
    // }
    return paramsPromise;
  });
  
  // return [openWindowPromise, win];
  const returnPromise = openWindowPromise.then(async (paramsPromise) => {
    let status: TransactionStatuses = 'PENDING';
    let result: T | undefined;
    const {checkStatus, checkoutSessionId, checkoutSessionsResponse, onSuccess, onFailure, onCancel, url} = paramsPromise;

    return new Promise<{status: TransactionStatuses; result?: T}>((resolve, _) => {
      const pollTimer = window.setInterval(() => {
        
        if (win?.closed !== false) {
          // !== is required for compatibility with Opera
          window.clearInterval(pollTimer);

          result = JSON.parse('{"link": "'+url+'"}');

          if (checkStatus && status === 'PENDING' && onCancel) {
            onCancel(checkoutSessionId, result);
          }
          
          status = 'CANCELLED';
          resolve({status, result});
        }
      }, POPUP_WINDOW_CLOSED_CHECK_INTERVAL);

      if (checkStatus) {
        poll({
          interval: POLL_FOR_CHECKOUT_STATUS_CHECK_INTERVAL,
          fn: async () => checkStatus(),
          validate: ({status: newStatus}) => (status !== 'PENDING' && status !== 'CANCELLED') || newStatus !== 'PENDING',
        })
          .then(({status: popupStatus, response}: {status: TransactionStatuses; response: T}) => {
            status = popupStatus;
            result = response;

            if (status === 'COMPLETED' && onSuccess) {
              onSuccess(checkoutSessionId, result);
            }
          })
          .catch((error) => {
            const httpError: HTTPErrorResponse = error.response.data;
            if (onFailure) {
              onFailure(checkoutSessionId, checkoutSessionsResponse, httpError);
            }
          })
          .finally(() => {
            win?.close();
            window.clearInterval(pollTimer);
            resolve({status, result});
          });
      }
    });
  });

  return [returnPromise, win];
}
